import React, { useState, Fragment } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fade from "@material-ui/core/Fade";
import ReactSelect from "react-select";
import MenuList from "../../../components/ContentUpload/MenuList";
import SingleValue from "../../../components/ContentUpload/SingleValue";
import ImageUpload from "../../../components/ContentUpload/ImageUpload";
import VideoUpload from "../../../components/ContentUpload/VideoUpload";
import YoutubeInput from "../../../components/ContentUpload/YoutubeInput";
import { ContentTypes } from "../../../Constants/selections";
import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
} from "../../../Constants/types";
import {
  UPLOADING_VIDEO,
  UPLOADING_IMAGE,
  UPLOADING_GIF,
} from "../../../Constants/string";
import Firebase from "../../../firebasehelper";
const AddTopicModal = ({ onCreate }) => {
  const [title, setTitle] = useState("");
  const [media_type, setMediaType] = useState("");
  const [media_url, setMediaURL] = useState("");
  const [loading_script, setLoadingScript] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChangeTitle = ({ target }) => {
    setTitle(target.value);
  };
  const handleChangeDescription = ({ target }) => {
    setDescription(target.value);
  };
  const handleSelectContentType = (value) => {
    setMediaType(value.value);
  };
  const uploadContent = (contentType) => async (mediaContent) => {
    const uploadFolder = "advent_planner/";
    const title = new Date().getTime().toString();
    if (contentType === GIF_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_GIF);
      let gif_url = await Firebase.uploadGif(
        mediaContent,
        title,
        uploadFolder + "/gifs"
      );
      setLoading(false);
      setMediaURL(gif_url);
    } else if (contentType === IMAGE_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_IMAGE);
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      setLoading(false);
      setMediaURL(img_url);
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      setLoading(true);
      setLoadingScript(UPLOADING_VIDEO);
      uploadTask.on(
        "state_changed",
        handleUploadProgress,
        handleUploadError,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            setLoading(false);
            setLoadingScript("");
            setMediaURL(downloadURL);
          });
        }
      );
    } else if (contentType === YOUTUBE_URL) {
      setMediaURL(mediaContent);
    }
  };
  const handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    setLoadingScript(loading_script);
  };

  const handleUploadError = (error) => {
    setLoadingScript("");
    setLoading(false);
  };
  return (
    <div
      className="modal fade"
      id="add_daily_topic_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add a daily topic</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1">
            <p className="add-event-title">Topic title</p>
            <input
              className="form-control form-control-md mb-2"
              onChange={handleChangeTitle}
              value={title}
            />
            <ReactSelect
              value={
                media_type ? { label: media_type, value: media_type } : null
              }
              onChange={handleSelectContentType}
              options={ContentTypes}
              placeholder="What content would you like to post?"
              isSearchable={false}
              components={{ MenuList, SingleValue }}
            ></ReactSelect>
            {media_type && (
              <div className="col-div m-2">
                {media_type === YOUTUBE_URL && (
                  <YoutubeInput onChangeContent={uploadContent(YOUTUBE_URL)} />
                )}
                {media_type === IMAGE_UPLOAD && (
                  <ImageUpload onChangeContent={uploadContent(IMAGE_UPLOAD)} />
                )}
                {media_type === GIF_UPLOAD && (
                  <ImageUpload
                    isGif={true}
                    onChangeContent={uploadContent(GIF_UPLOAD)}
                  />
                )}
                {media_type === VIDEO_UPLOAD && (
                  <VideoUpload onChangeContent={uploadContent(VIDEO_UPLOAD)} />
                )}
              </div>
            )}
            <Fade
              in={loading}
              style={{
                transitionDelay: loading ? "800ms" : "0ms",
              }}
              unmountOnExit
            >
              <Fragment>
                <p>{loading_script}</p>
                <CircularProgress />
              </Fragment>
            </Fade>
            <p className="add-event-title mt-2">Description</p>
            <textarea
              maxLength="280"
              className="form-control form-control-md"
              onChange={handleChangeDescription}
              value={description}
            />
            <p className="bottom-small-text">Max characters: 280</p>

            <div className="modal-footer">
              <button
                className="btn btn-green"
                onClick={() =>
                  onCreate({ title, media_url, media_type, description })
                }
                data-dismiss="modal"
              >
                Create
              </button>
              <button className="btn btn-orange" data-dismiss="modal">
                Later
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddTopicModal;



// WEBPACK FOOTER //
// ./src/screens/AdventPlanner/components/AddTopicModal.js